import React from 'react';
import './FileView.scss';
import DocumentView from './FiletypeViews/DocumentView';
import AudioView from './FiletypeViews/AudioView';
import PhotoView from './FiletypeViews/PhotoView';
import VideoView from './FiletypeViews/VideoView';
import OtherView from './FiletypeViews/OtherView';

class FileView extends React.Component{

  constructor(){
    super(...arguments);

    this.props.file.ensureLoaded().then(() => {
      this.forceUpdate();
    });
    let siteProps = FW.store.get('site').get('properties');
    this.socialProps = siteProps ? siteProps.social_media_settings ? siteProps.social_media_settings : {} : {};
  }

  componentDidMount(){
    this.props.file.on('change', () => {
      this.forceUpdate();
    }, this);
    let templateID = FW.store.get('template') ? FW.store.get('template').get('id') : -1;
    if(templateID === 3){
      $('#mainNav').removeClass('affix-top');
    }
  }

  componentWillUnmount(){
    this.props.file.off(null, null, this);
  }

  render(){
    let file = this.props.file;
    if (file.get('featured_image_file_id'))
      this.socialProps.picture = file.get('featured_image_file_id');
    this.socialProps.tags = this.socialProps.tags || '';
    file.get('tags').models.forEach((tag) => {
      this.socialProps.hashtags += ' ' + tag.get('title');
    });
    this.socialProps.title = file.get('title') || this.socialProps.title;
    this.socialProps.description = file.get('description') || this.socialProps.description;

    let userOwned = FW.store.get('user') && FW.store.get('user').get('purchased_files').indexOf(file.get('id')) >= 0;

    let content;

    switch (file.fileType){
      case 'image':
        content = <PhotoView file={file} social={this.socialProps} userOwned={userOwned}/>;
        break;
      case 'video':
        content = <VideoView file={file} social={this.socialProps} userOwned={userOwned}/>;
        break;
      case 'audio':
        content = <AudioView file={file} social={this.socialProps} userOwned={userOwned}/>;
        break;
      case 'document':
        content = <DocumentView file={file} social={this.socialProps} userOwned={userOwned}/>;
        break;
      case 'archive':
        content = <OtherView file={file} social={this.socialProps} userOwned={userOwned}/>;
        break;
      default:
        content = <OtherView file={file} social={this.socialProps} userOwned={userOwned}/>;
        break;
    }
    return (
      <div id='fileContainer' className={'clearfix'} style={{}}>
        {content}
      </div>
    );
  }

}

export default FileView;
